import Vue from 'vue';
import PortalVue from 'portal-vue';

export default function usePortals () {
  Vue.use(PortalVue);
}
